import api from '../api';
import myRewardsFooterAuthenticatedData from './my-rewards-footer-authenticated.json';
import myRewardsFooterData from './my-rewards-footer.json';

export const getNavigationContent = () => ({
  data: {
    logo: 'https://www.caesars.com/content/dam/caesars-rewards/logos/crw_navigation_logo.png',
    links: [
      {
        title: 'Benefits',
        url: '/myrewards/benefits-overview',
      },
      {
        title: 'Earn & Redeem',
        url: '/myrewards/earn-and-redeem',
      },
      {
        title: 'Promotions',
        url: '/myrewards/promotions',
      },
      {
        title: 'Partners',
        url: '/myrewards/partners',
      },
      {
        title: 'FAQs',
        url: '/myrewards/exchange',
      },
    ],
  },
});

export const getTierInformation = () => api.get('/api/v1/trtiers');

export const getMyRewardsFooterContent = () => {
  return {
    authenticated: myRewardsFooterAuthenticatedData,
    unAuthenticated: myRewardsFooterData,
  };
};

export const getEmpireFooterContent = () => api.get('/footer');
